export var StickyPlayerEvent;
(function (StickyPlayerEvent) {
    StickyPlayerEvent[StickyPlayerEvent["TIME_CHANGED"] = 0] = "TIME_CHANGED";
    StickyPlayerEvent[StickyPlayerEvent["CHANGE_CURRENT_TIME"] = 1] = "CHANGE_CURRENT_TIME";
    StickyPlayerEvent[StickyPlayerEvent["FORCE_HIDE"] = 2] = "FORCE_HIDE";
})(StickyPlayerEvent || (StickyPlayerEvent = {}));
